<i18n>
{
  "de": {
    "signup": "Registrieren",
    "welcomeHeading": "Willkommen auf getnext!",
    "welcomeText": "Auf getnext bieten Künstlern/-innen und Stars exklusiven Zugang zu Videos, Musik, Making-Of-Material, persönlichen Treffen, VIP-Paketen, Vorab-Premieren, Erstzugang zu Tickets und vielem mehr.",
    "undisturbedTitle": "Ungestört",
    "undisturbedText": "getnext ist frei von Werbung.",
    "privacyTitle": "Privatsphäre",
    "privacyText": "Wir teilen und verkaufen Deine Nutzungsdaten nicht an Dritte.",
    "registerNowTitle": "Jetzt registrieren",
    "registerNowText": "Die Anmeldung ist kostenlos.",
    "artistSignupText": "Wenn Du Künstler/-in bist",
    "artistSignupAnchor": "klicke bitte hier",
    "thankYou": "Vielen Dank!",
    "registrationSent": "Du erhältst nun eine Mail von uns. Zur abschließenden Bestätigung Deiner Anmeldung bitte wir Dich, den enthaltenen Link anzuklicken.",
    "email": "E-Mail-Adresse",
    "nickName": "Nickname",
    "password": "Passwort",
    "mandatory": "Pflichtfelder",
    "createAccount": "Account erstellen",
    "policyAcceptance": "Für die Nutzung der Plattform gelten die",
    "terms": "Allgemeinen Nutzungsbedingungen"
  },
  "en": {
    "signup": "Sign up",
    "welcomeHeading": "Welcome to getnext!",
    "welcomeText": "At getnext, artists and stars offer exclusive access to videos, music, making-of material, personal meetings, VIP packages, previews, early access to tickets and much more.",
    "undisturbedTitle": "Just Joy",
    "undisturbedText": "getnext is free of advertising.",
    "privacyTitle": "Privacy",
    "privacyText": "We do not share or sell your usage data to third parties.",
    "registerNowTitle": "Join now",
    "registerNowText": "The sign up is free.",
    "artistSignupText": "If you are an artist",
    "artistSignupAnchor": "please click here",
    "thankYou": "Thank you!",
    "registrationSent": "You will receive an email from us confirming your sign up request. Please click on the included confirmation link to complete your registration.",
    "email": "Email",
    "nickName": "Nickname",
    "password": "Password",
    "mandatory": "Mandatory fields",
    "createAccount": "Create account",
    "policyAcceptance": "By creating your account, you agree to our",
    "terms": "terms and conditions"
  }
}
</i18n>

<template>
  <div>
    <h3 class="title is-2 has-text-centered">
      {{ $t('signup') }}
    </h3>
    <div
      v-if="!socialRegistration"
      class="columns mt-25 mb-25"
    >
      <div class="column is-6 is-offset-3 mdc-theme--light">
        <h3 class="title is-5 is-primary-color is-bold is-italic">
          {{ $t('welcomeHeading') }}
        </h3>
        <p>{{ $t('welcomeText') }}</p>
        <dl
          id="registration-description-list"
          class="mt-10 mb-15"
        >
          <dt>{{ $t('undisturbedTitle') }}</dt>
          <dd>{{ $t('undisturbedText') }}</dd>
          <dt>{{ $t('privacyTitle') }}</dt>
          <dd>{{ $t('privacyText') }}</dd>
          <dt>{{ $t('registerNowTitle') }}</dt>
          <dd>{{ $t('registerNowText') }}</dd>
        </dl>
        <p>
          {{ $t('artistSignupText') }}, <a href="/#apply">
            {{ $t('artistSignupAnchor') }}</a>.
        </p>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6 is-offset-3 mdc-theme--light">
        <div v-if="registrationSent">
          <h4 class="has-text-centered">
            {{ $t('thankYou') }}
          </h4>
          <h4 class="has-text-centered">
            {{ $t('registrationSent') }}
          </h4>
        </div>
        <div v-if="!registrationSent">
          <socialLogin
            :divider="!socialRegistration"
            :params="{
              returnRouteObject: {
                route: {
                  name: `index___${$i18n.locale}`,
                },
                locales: $root.$i18n['locales'],
                locale: $i18n.locale
              }
            }"
            @registration="setSocialRegistration"
            @logged="$emit('logged')"
          />
          <form
            v-if="!socialRegistration"
            novalidate
            method="post"
            @submit.prevent="submitRegistration"
          >
            <div class="columns is-gapless is-formfields">
              <div class="column">
                <input-text
                  id="email"
                  v-model="email"
                  :label="$t('email')"
                  name="email"
                  validate="required|validEmailAddress|uniqueEmailAddress"
                  class="is-medium"
                />
              </div>
            </div>
            <div class="columns is-gapless is-formfields">
              <div class="column">
                <input-text
                  id="nickname"
                  v-model="nickname"
                  name="nickname"
                  :label="$t('nickName')"
                  validate="required|uniqueNickname"
                  class="is-medium"
                />
              </div>
            </div>
            <div class="columns is-gapless is-formfields">
              <div class="column">
                <input-text
                  id="password"
                  v-model="password"
                  type="password"
                  name="password"
                  :label="$t('password')"
                  validate="required|passwordStrength"
                  class="is-medium"
                />
                <passwordMeter
                  id="passwordMeter"
                  :value="password"
                />
              </div>
            </div>
            <div class="columns is-gapless is-formfields">
              <div class="column">
                <div class="field">
                  {{ $t('policyAcceptance') }} <nuxt-link
                    :to="localePath({ name: 'portal-static-terms' })"
                    target="_blank"
                  >
                    {{ $t('terms')
                    }}
                  </nuxt-link>.
                </div>
              </div>
            </div>
            <div class="columns is-gapless">
              <div class="column">
                (*) {{ $t('mandatory') }}
              </div>
            </div>
            <div class="control mt-50">
              <button
                id="submit"
                type="submit"
                :disabled="errors.any()"
                class="button is-primary is-outlined is-fullwidth is-medium"
              >
                {{ $t('createAccount') }}
              </button>
              <input
                type="submit"
                style="position: absolute; left: -9999px"
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import passwordMeter from '~/components/password-meter'
import socialLogin from '~/components/social-login'

export default {
  name: 'signUpIndex', // required
  serverCacheKey: () => 'signup-index', // @see https://ssr.vuejs.org/guide/caching.html#component-level-caching
  inject: ['$validator'],
  components: { passwordMeter, socialLogin },
  data: () => ({
    title: 'Sign up',
    nickname: '',
    email: '',
    password: '',
    registrationSent: false,
    socialRegistration: false
  }),
  scrollToTop: true,
  // expose data to head of website
  // @note: error function returns 'undefined'!
  head() {
    return {
      title: this.title
    }
  },

  mounted() {
    this.$validator.localize(this.$i18n.locale)
  },

  methods: {
    async submitRegistration() {
      const valid = await this.$validator.validateAll()
      if (valid) {
        const result = await this.apiPost('/api/private/register', this.$data)
        if (result) {
          this.registrationSent = true
        }
      }
    },
    setSocialRegistration(value) {
      this.socialRegistration = value
    }
  }
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';

.is-primary-color {
  color: var(--primary-color);
}

.is-bold {
  font-weight: 500;
}

.is-italic {
  font-style: italic;
}

#registration-description-list {
  display: flex;
  flex-flow: row wrap;

  dt {
    flex-basis: 30%;
    padding: 2px 4px 2px 0px;
    color: var(--primary-color);
  }

  dd {
    flex-basis: 70%;
    flex-grow: 1;
    margin: 0;
    padding: 2px 4px;
  }

  @media only screen and (max-width: $mobile) {
    dt {
      flex-basis: 40%;
    }

    dd {
      flex-basis: 60%;
    }
  }

}
</style>
